var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_491",
    "data-name": "Grupo 491",
    transform: "translate(-1633 -1426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_105",
    "data-name": "Rect\\xE1ngulo 105",
    width: 26,
    height: 26,
    transform: "translate(1633 1426)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght300_GRAD0_opsz40",
    d: "M141.183-804.78h1.038l10.561-10.552-1.038-1.038-10.561,10.552Zm-.446,1.182a.714.714,0,0,1-.526-.21.714.714,0,0,1-.21-.526v-1.357a1.442,1.442,0,0,1,.119-.577,1.453,1.453,0,0,1,.322-.474l12.511-12.512a1.346,1.346,0,0,1,.387-.244,1.172,1.172,0,0,1,.457-.091,1.205,1.205,0,0,1,.446.086,1.243,1.243,0,0,1,.4.254l1.025,1.03a1.025,1.025,0,0,1,.257.395,1.315,1.315,0,0,1,.079.443,1.232,1.232,0,0,1-.087.453,1.192,1.192,0,0,1-.248.392l-12.521,12.5a1.452,1.452,0,0,1-.474.322,1.441,1.441,0,0,1-.577.12Zm14.081-13.794L153.8-818.4Zm-2.554,1.547-.519-.524,1.038,1.038Z",
    transform: "translate(1497.996 2250.594)",
    fill: "#00bdd9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.2ccf930bc2fc4683268c19e611419c94.svg";
export { ForwardRef as ReactComponent };